<template lang="pug">
.map-attribution(v-html="attribution")
</template>

<script>
export default {
  computed: {
    attribution () {
      return this.$store.getters.attribution
    }
  }
}
</script>
